<template>
  <div class="content-wrap">
    <div v-if="isMultiFunctionText" v-html="text" ref="content" class="content multi-func-text" :style="multiFunctionTextStyle"></div>
    <div v-else ref="content" class="content" :style="contentStyle" >{{ text }}</div>
    <div v-if="needShowExpand" class="expand-button-wrap">
      <div class="expand-button" @click="expandClick">{{ expand ? $t('common.btn.collapse') : $t('common.btn.expand') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 需要展示的文本
    text: {
      type: String,
      default: ''
    },
    // 行高
    lineHeight: {
      type: Number,
      default: 22
    },
    // 展示的行数
    rows: {
      type: Number,
      default: 1
    },
    // 是否是富文本形式
    isMultiFunctionText: {
      type: Boolean,
      default: false
    },
    // 若是传入的文本是富文本，则需要指定高度, 默认300
    height: {
      type: Number,
      default: 300
    }
  },
  data () {
    return {
      expand: true,
      needShowExpand: false,
      heightLimit: null
    }
  },
  computed: {
    contentStyle () {
      const style = {
        lineHeight: `${this.lineHeight}px`
      }
      if (!this.expand) {
        style['-webkitLineClamp'] = this.rows
      }

      return style
    },
    multiFunctionTextStyle () {
      const style = {
        height: 'auto',
        maxHeight: null
      }
      if (!this.expand) {
        style.maxHeight = `${this.height}px`
      }

      return style
    }
  },
  created () {
    this.heightLimit = this.isMultiFunctionText ? this.height : this.lineHeight
  },
  mounted () {

  },
  methods: {
    expandClick () {
      this.expand = !this.expand
    },
    initTextStyle () {
      if (this.$refs.content.offsetHeight >= this.heightLimit * this.rows) {
        this.expand = false
        this.needShowExpand = true
      } else {
        this.expand = true
        this.needShowExpand = false
      }
    }
  },
  watch: {
    text: {
      handler () {
        if (!this.text) {
          return
        }
        this.$nextTick(() => {
          this.initTextStyle()
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrap {
  .content {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .expand-button-wrap {
    height: 22px;

    .expand-button {
      padding-right: 8px;
      text-align: right;
      vertical-align: middle;
      color: #0096cc;
      font-size: 14px;
      line-height: 22px;
    }
  }

  .multi-func-text {
    ::v-deep {
      html,
      body,
      div,
      span,
      applet,
      object,
      iframe,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      blockquote,
      pre,
      a,
      abbr,
      acronym,
      address,
      big,
      cite,
      code,
      del,
      dfn,
      em,
      font,
      ins,
      kbd,
      q,
      s,
      samp,
      small,
      strike,
      strong,
      sub,
      sup,
      tt,
      var,
      dl,
      dt,
      dd,
      ol,
      ul,
      li,
      fieldset,
      form,
      label,
      legend,
      table,
      caption,
      tbody,
      tfoot,
      thead,
      tr,
      th,
      td {
          border: 0;
          font-size: 100%;
          margin: 0;
          outline: 0;
          padding: 0;
          vertical-align: baseline;
      }
    }
  }
}
</style>
